import React, { Fragment, useEffect, useState } from 'react'

// third party components
import { Dialog, Transition } from '@headlessui/react'

// styles
import styles from './index.module.scss'
import GradientButton from 'components/Button/GradientButton'
import OutlineButton from 'components/Button/OutlineButton'
import { useViewport } from 'utils'

const RemoveMerchSudioModal = props => {
  const { open, close, onContinue } = props
  const viewport = useViewport()

  const [show, setShow] = useState(false)

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setShow(true)
      }, 100)
    }
  }, [open])

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className={styles.container} onClose={() => close()}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={styles.bgView} />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className={`${styles.modalView} ${show ? styles.show : styles.hide}`}>
                <div className={styles.title}>Disable Physical Prints</div>

                <div className="w-full mt-[15px] px-[16px] sm:px-[45px] sm:mt-[30px]">
                  <div className={styles.text}>
                    Are you sure you would like to disable physical print purchase options?
                  </div>
                </div>

                <div className="w-full flex justify-center sm:justify-end sm:px-[50px] px-[16px] mb-[30px] mt-[15px] sm:mt-[35px] ">
                  <div className="sm:hidden w-full flex gap-[15px] flex-col">
                    <GradientButton
                      label={'Continue'}
                      fullWidth={viewport === 'xs'}
                      width={viewport === 'xs' ? '100%' : 122}
                      onClick={onContinue}
                    />
                    <OutlineButton
                      label={'Cancel'}
                      onClick={close}
                      fullWidth={viewport === 'xs'}
                      width={viewport === 'xs' ? '100%' : 106}
                      borderColor="var(--bg-FFF-202427)"
                    />
                  </div>
                  <div className="hidden sm:flex w-auto flex gap-[15px] flex-row">
                    <OutlineButton
                      label={'Cancel'}
                      onClick={close}
                      fullWidth={viewport === 'xs'}
                      width={viewport === 'xs' ? '100%' : 106}
                      borderColor="var(--bg-FFF-202427)"
                    />
                    <GradientButton
                      label={'Continue'}
                      fullWidth={viewport === 'xs'}
                      width={viewport === 'xs' ? '100%' : 122}
                      onClick={onContinue}
                    />
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default RemoveMerchSudioModal
